export default function HookSection() {
  return (
    <section className="py-20 px-6 bg-gradient-to-br from-amber-50 to-orange-50">
      <div className="max-w-3xl mx-auto">
        <div className="space-y-6 text-lg md:text-xl text-gray-700 leading-relaxed">
          <p className="text-2xl md:text-3xl font-bold text-gray-900">
            If it feels icky, it is.
          </p>
          
          <p>
            ICK is your signal something's off: rushed energy, generic outreach, agenda-first pitches.
          </p>
          
          <p>
            STICK is different. It's an acronym for the 5 qualities that make partnerships last.
          </p>
          
          <p>
            Download the guide to learn the framework, see 10 practical examples, and start attracting aligned partnerships.
          </p>
        </div>
        
        <div className="text-center mt-12">
          <a 
            href="https://www.dropbox.com/scl/fi/0bwab3azryg18qqgsqeep/icktostickeguide.pdf?rlkey=2cmr5nmw9f8cn6q5jb1ge0be7&st=2fdakuja&dl=0" 
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-amber-600 hover:bg-amber-700 text-white font-semibold px-12 py-5 rounded-full text-xl transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Download the Free Guide
          </a>
        </div>
      </div>
    </section>
  );
}
